
    /**
     * @description
     *  Modelo de una consulta paginada.
     *
     * @template T
     *  El tipo de los elementos consultados.
     *
     * @see gigot-backend/Services/QueryParams/PagedQuery.cs
     */

export class PagedQuery<T> {

    public filter: T;
    public pageNumber: number;
    public pageSize: number;
    public sortField: string;
    public sortOrder: string;

    constructor(builder: PagedQueryBuilder<T>) {
        this.filter = builder._filter;
        this.pageNumber = builder._pageNumber;
        this.pageSize = builder._pageSize;
        this.sortField = builder._sortField;
        this.sortOrder = builder._sortOrder;
    }

    /**
     * @description
     *	Construye una consulta paginada con una semántica vacía. Nótese que
     *  no es lo mismo que construir una consulta con valores por defecto. Las
     *  reglas generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Una consulta paginada vacía.
     */
    public static empty<T>(): PagedQuery<T> {
        return new PagedQueryBuilder<T>().build();
    }
}

    /**
     * @description
     *  Patrón builder para la clase PagedQuery.
     */

export class PagedQueryBuilder<T> {

    public _filter: T;
    public _pageNumber: number;
    public _pageSize: number;
    public _sortField: string;
    public _sortOrder: string;

    constructor() {
        this._filter = undefined;
        this._pageNumber = undefined;
        this._pageSize = undefined;
        this._sortField = "";
        this._sortOrder = "";
    }

    public build(): PagedQuery<T> {
        return new PagedQuery<T>(this);
    }

    public filter(filter: T): PagedQueryBuilder<T> {
        this._filter = filter;
        return this;
    }

    public pageNumber(pageNumber: number): PagedQueryBuilder<T> {
        this._pageNumber = pageNumber;
        return this;
    }

    public pageSize(pageSize: number): PagedQueryBuilder<T> {
        this._pageSize = pageSize;
        return this;
    }

    public sortField(sortField: string): PagedQueryBuilder<T> {
        this._sortField = sortField;
        return this;
    }

    public sortOrder(sortOrder: string): PagedQueryBuilder<T> {
        this._sortOrder = sortOrder;
        return this;
    }
}
